import {connect} from "react-redux";
import NoCases
from "../../../../components/Home/Pages/CareManagerColumn/CareManagerColumnsComponents/NoCases";
import {setShowOfferModal, setShowVideoModal} from "../../../../actions/modal";

export const MapStateToProps = (state) => ({
showOfferModal: state.modal.showOfferModal,
showVideoModal: state.modal.showVideoModal,
listCases: state.cases.listCases,
isSouscription: state.user.isSouscription
});

export const MapDispatchToProps = (dispatch) => ({
setShowOfferModal: (bool) => {
dispatch(setShowOfferModal(bool));
},
setShowVideoModal: (bool) => {
dispatch(setShowVideoModal(bool));
},
});

export default connect(MapStateToProps, MapDispatchToProps)(NoCases);